
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22","cy":"22","r":"16","fill":"#F2F3F5"}}),_c('path',{attrs:{"d":"M15 19.215v7.23c0 .859.696 1.555 1.555 1.555h10.887c.86 0 1.555-.696 1.555-1.555v-7.23","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M15.69 17.924l5.438-3.659a1.56 1.56 0 011.741 0l5.44 3.66a1.555 1.555 0 010 2.58L23.74 23.58a3.118 3.118 0 01-3.482 0l-4.568-3.073a1.555 1.555 0 010-2.582z","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.76 23.24l-4.301 4.302M28.54 27.542l-4.301-4.301","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    